/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule1_ActionInputs */

const tr_landing_pricerules_mock_rule1_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektronik kategorisinde kur oranında zam`)
};

const en_landing_pricerules_mock_rule1_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electronics rise in line with the rate`)
};

const de_landing_pricerules_mock_rule1_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektronik steigt im Verhältnis zum Kurs`)
};

const ru_landing_pricerules_mock_rule1_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule1_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электроника дорожает пропорционально курсу`)
};

/**
* | output |
* | --- |
* | "Electronics rise in line with the rate" |
*
* @param {Landing_Pricerules_Mock_Rule1_ActionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule1_action = /** @type {((inputs?: Landing_Pricerules_Mock_Rule1_ActionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule1_ActionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule1_action(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule1_action(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule1_action(inputs)
	return tr_landing_pricerules_mock_rule1_action(inputs)
});